import { render, staticRenderFns } from "./chartererFreight.vue?vue&type=template&id=26c68806"
import script from "./chartererFreight.vue?vue&type=script&lang=js"
export * from "./chartererFreight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports